import { DEVICES } from './devices';
import type { BrowserViewport, CustomViewport } from '../types';

export const DESKTOP_VIEWPORTS: BrowserViewport[] = [
  { id: 'desktop-1280', name: 'Laptop', width: 1280, height: 800 },
  { id: 'desktop-1440', name: 'Desktop', width: 1440, height: 900 },
  { id: 'desktop-1920', name: 'Full HD', width: 1920, height: 1080 },
].map(view => ({ ...view, category: 'desktop', brand: 'Desktop', os: 'browser', notch: 'none', pixelRatio: 1 }));

export function customViewports(values: CustomViewport[] = []): BrowserViewport[] {
  const ids = new Set([...DEVICES, ...DESKTOP_VIEWPORTS].map(view => view.id));
  return values.map(view => {
    if (!/^[a-zA-Z0-9_-]+$/.test(view.id) || ids.has(view.id)) throw new Error('Custom viewport IDs must be unique letters, numbers, hyphens or underscores.');
    if (!view.name.trim() || view.name.length > 80) throw new Error('Custom viewport names must contain 1–80 characters.');
    if (![view.width, view.height].every(n => Number.isInteger(n) && n >= 240 && n <= 3840)) throw new Error('Viewport dimensions must be integers between 240 and 3840.');
    ids.add(view.id);
    return { ...view, category: 'custom', brand: 'Custom', os: 'browser', notch: 'none', pixelRatio: 1 };
  });
}
